import { rolesForTranslations, RowIDStatus } from 'const';
import { extractCompleteDate, extractDate } from 'utils/date-format';

export const transformData = (data, corporate = false) => {
  return {
    ...data,
    webUserList: [...data.webUserList].map(row => ({
      ...row,
      originalRole: row.role,
      role: rolesForTranslations[row.role],
      createdOn: extractCompleteDate(row.createdOn),
      updatedOn: extractCompleteDate(row.updatedOn)
    }))
  };
};

export const downloadCSVFIle = (data, fileName) => {
  const fileUrl = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = fileUrl;
  link.setAttribute('download', `${fileName || 'sample.csv'}`);

  document.body.appendChild(link);
  link.click();

  link.remove();
};

export const getBase64Format = (file, cb) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function() {
    cb(reader.result);
  };
  reader.onerror = function(error) {
    console.log('Error: ', error);
  };
};

export const transformCSVHistoryData = data => {
  let historyList = data;
  historyList = historyList.map(row => {
    row.uploadDate = extractDate(row.uploadDate);
    return row;
  });
  return historyList;
};

export const transformHistoryRowData = data => {
  let rowData = data;
  rowData = rowData.map(row => {
    row.rowIndex = `Row ${row.rowId}`;
    row.status = row.rowIdStatus;
    row.message =
      row.rowIdStatus === RowIDStatus.CREATED ? 'No issue' : row.message;
    return row;
  });
  return rowData;
};

export const parseResponseFromBECorporate = data => ({
  pageNo: data.currentPage,
  totalRecordsAcrossAllPages: data.totalItems,
  totalPagesAvailable: data.totalPages,
  webUserList: data.webUserList
});
